import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { List, Table } from 'antd'

import { req_list_cfs_workflow } from '../../api'
import storageUtils from '../../utils/storageUtils'
import { formateDate } from '../../utils/dateUtil'

export default class MyApplyCaseWorkflow extends Component {

    // 基礎通用參數 ////////////////////////////////////////////// 

    state = {
        workflows: [],
    }

    static propTypes = {
        CaseNid: PropTypes.number.isRequired
    }

    UNSAFE_componentWillMount() {
        this.api_list_workflow(this.props.CaseNid)
        this.init_columns()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_workflow = async (id) => {

        this.setState({ loading: true })
        const result = await req_list_cfs_workflow(id, storageUtils.getUser().token)
        this.setState({ loading: false })

        // console.log(result)
        if (result.total > 0) {
            const workflows = result.data
            this.setState({ workflows })
            
        }
    }

    // 數據配置設定 //////////////////////////////////////////////    

    init_columns = () => {
        this.columns = [
            {
                title: '紀錄日期',
                dataIndex: 'RecordDateTime',
                width: 65,
                render: (RecordCreateDateTime) => formateDate(RecordCreateDateTime),
            },
            {
                title: '紀錄說明',
                dataIndex: 'RecordDescription',
                width: 100,
            },
            {
                title: '記錄人員',
                dataIndex: 'Name',
                width: 60,
                responsive: ['md'],
            }
        ]

    }


    ////////////////////////////////////////////////////////////       

    render() {
        // const { CaseNid } = this.props
        const { workflows } = this.state
        return (
            <List>
                <Table dataSource={workflows} columns={this.columns} pagination={false} />
            </List>
        )
    }
}